import React, { useState, useEffect, useRef } from 'react'
import styles from './product.module.scss'

import { ACTION, ROUTES, PERMISSIONS } from 'consts'
import { generatorTreeNodeCategories, removeAccents } from 'utils'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { CKEditor } from 'ckeditor4-react'
import parse from 'html-react-parser'
import delay from 'delay'
import { getSignedUrl } from 'utils/upload'
//components
import NotSupportMobile from 'components/not-support-mobile'
import TitlePage from 'components/title-page'
import Permission from 'components/permission'

//antdu
import {
  Button,
  Table,
  Input,
  Form,
  Row,
  Col,
  InputNumber,
  Select,
  Upload,
  notification,
  Popconfirm,
  Tooltip,
  Space,
  Modal,
  Tabs,
  TreeSelect,
  Badge,
  Checkbox,
  Switch,
} from 'antd'

//icons
import {
  ArrowLeftOutlined,
  InboxOutlined,
  CloseOutlined,
  PlusOutlined,
  EditOutlined,
  FileImageOutlined,
  DollarOutlined,
  ReloadOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  LoadingOutlined,
  CloseCircleFilled,
} from '@ant-design/icons'

//apis
import { getCategories } from 'apis/category'
import { uploadFiles, uploadFile } from 'apis/upload'
import { getWarranties, addWarranty } from 'apis/warranty'
import {
  updateSetMenu,
  addSetMenu,
  getSetMenu
} from 'apis/set-menu'
import { getTaxList } from 'apis/tax'
import { getPromotions } from 'apis/promotion'
import { getToppingList } from 'apis/topping'
import { getBranches } from 'apis/branch'
import { getCountries } from 'apis/country'
import { getRegions } from 'apis/region'
import _ from 'lodash'

export default function ProductAdd() {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const [form] = Form.useForm()
  const [formGuarantee] = Form.useForm()
  const search = location.search
  const productId = new URLSearchParams(search).get('product_id')
  console.log("productId", productId);
  const ATTRIBUTES_DEFAULT = [
    { option: 'unit', values: ['9 oz | 250g', '13 oz | 350g', '18 oz | 500g'] },
    { option: 'type', values: ['PLATINUM', 'USDA PRIME', 'AUSTRALIA'] },
  ]

  const [isIncludeTax, setIsIncludeTax] = useState(false)
  const [isSpecial, setIsSpecial] = useState(false)
  const [isMarginRight, setIsMarginRight] = useState(false)
  const [isSellByGam, setIsSellByGam] = useState(false)
  const [product, setProduct] = useState(null)
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState([])
  const [categoriesSelect, setCategoriesSelect] = useState([])
  const [taxList, setTaxList] = useState([])
  const [toppings, setToppings] = useState([])
  const [branches, setBranches] = useState([])
  const [countries, setCountries] = useState([])
  const [regions, setRegions] = useState([])
  const [keyTab, setKeyTab] = useState('1')
  const [isRenderFirst, setIsRenderFirst] = useState(location.state ? false : true)
  const [isMobile, setIsMobile] = useState(false)
  const [description, setDescription] = useState('')
  const [imagesProduct, setImagesProduct] = useState([])
  const [loadingUpload, setLoadingUpload] = useState(false)

  const [bulkPrice, setBulkPrice] = useState({
    min_quantity_apply: 1,
    max_quantity_apply: 20,
    price: 0,
  })




  const _addOrUpdateProduct = async () => {
    await form.validateFields()

    try {
      const formProduct = form.getFieldsValue()

      let body = {
        ...formProduct,
        description: description,
        image_urls: imagesProduct
      }


      setLoading(true)
      let res
      //case update product
      console.log("_addOrUpdateProduct", product);
      if (product) res = await updateSetMenu(product.product_id, body);
      else res = await addSetMenu(body)
      setLoading(false)
      console.log(res)
      if (res.status === 200) {
        notification.success({
          message: `${product ? 'Cập nhật' : 'Tạo'} ${body.name} thành công!`,
        })
        history.goBack()
      } else
        notification.error({
          message:
            res.data.message || `${product ? 'Cập nhật' : 'Tạo'} ${body.name} thất bại!`,
        })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const _getCategories = async () => {
    try {
      const res = await getCategories({ parent: true })
      if (res.status === 200) {
        if (res.data.data && res.data.data.length) {

          setCategories(res.data.data.map((e) => generatorTreeNodeCategories(e)))
        }
      }
    } catch (error) {
      console.log(error)
    }
  }






  const _getBranches = async () => {
    try {
      const res = await getBranches()
      if (res.status === 200) {
        setBranches(res.data.data)
      }
    } catch (error) { }
  }

  const _getRegions = async () => {
    try {
      const res = await getRegions()
      if (res.status === 200) setRegions(res.data.data)
    } catch (error) { }
  }

  const _getCountries = async () => {
    try {
      const res = await getCountries()
      if (res.status === 200) setCountries(res.data.data)
    } catch (error) { }
  }

  const initProductWithEditProduct = async () => {
    // get product detail with query product_id
    let productUpdate = null
    if (productId) {
      const res = await getSetMenu({ code: productId })
      if (res.status === 200)
        if (res.data.data && res.data.data.length) productUpdate = res.data.data[0]
    }

    setKeyTab('2')
    if (location.state || productId) {
      const product = location.state || productUpdate
      setProduct({ ...product })
      console.log(product)




      if (product.region_infos) {
        var region_ids = []
        for (var i = 0; i < product.region_infos.length; i++) {
          region_ids.push(product.region_infos[i].region_id)
        }
        product.region_ids = region_ids
      }

      if (product.country_infos) {
        var country_ids = []
        for (var i = 0; i < product.country_infos.length; i++) {
          country_ids.push(product.country_infos[i].country_id)
        }
        product.country_ids = country_ids
      }

      form.setFieldsValue({
        ...product,

      })


      await Promise.all(product.image_urls.map(async (img, index) => {
        product.image_urls[index] = await getSignedUrl(img);
      }));
      setImagesProduct(product.image_urls || [])
      setDescription(product.description || '')
    }

    await delay(100)
    setIsRenderFirst(true)
    setKeyTab('3')
    await delay(100)
    setKeyTab('1')
  }



  useEffect(() => {
    _getCategories()
    // _getWarranties()


    _getBranches()
    _getCountries()
    _getRegions()

  }, [])

  //get width device
  // useEffect(() => {
  //   if (window.innerWidth < 768) setIsMobile(true)
  //   else setIsMobile(false)
  // }, [])



  //update product
  useEffect(() => {
    initProductWithEditProduct()
  }, [])

  return !isMobile ? (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <TitlePage
        title={
          <Row
            wrap={false}
            align="middle"
            style={{ cursor: 'pointer' }}
            onClick={() =>
              history.push(ROUTES.SETMENU)
            }
          >
            <ArrowLeftOutlined style={{ marginRight: 8 }} />
            (
            <div>{product ? 'Cập nhật set menu' : 'Thêm mới set menu'}</div>
            )
          </Row>
        }
      >
        <Space>
          <Button
            loading={loading}
            icon={<EditOutlined />}
            size="large"
            type="primary"
            onClick={_addOrUpdateProduct}
          >
            {product ? 'Cập nhật' : 'Thêm'}
          </Button>
        </Space>
      </TitlePage>

      <Form form={form} layout="vertical" style={{ width: '100%', marginTop: 15 }}>
        <Tabs activeKey={keyTab} type="card" onChange={setKeyTab}>
          <Tabs.TabPane tab={`Thông tin set menu`} key="1">
            <Row gutter={[10, 10]} align="middle">
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  label={`Tên món ăn`}
                  name="name"
                  rules={[{ required: true, message: `Vui lòng nhập tên món ăn!` }]}
                >
                  <Input size="large" placeholder={`Nhập tên món ăn`} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng chọn quốc gia' }]}
                  label="Quốc gia"
                  name="country_ids"
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    size="large"
                    allowClear
                    optionFilterProp="children"
                    showSearch
                    placeholder="Chọn quốc gia"
                  >
                    {countries.map((country, index) => (
                      <Select.Option key={index} value={country.country_id}>
                        {country.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item
                  rules={[{ required: true, message: 'Vui lòng chọn khu vực' }]}
                  label="Khu vực"
                  name="region_ids"
                >
                  <Select
                    maxTagCount="responsive"
                    mode="multiple"
                    size="large"
                    allowClear
                    optionFilterProp="children"
                    showSearch
                    placeholder="Chọn khu vực"
                  >
                    {regions.map((region, index) => (
                      <Select.Option key={index} value={region.region_id}>
                        {region.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Độ ưu tiên (từ thấp đến cao)" name="priority">
                  <Input size="large" placeholder={`Nhập độ ưu tiên`} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <Form.Item label="Giá bán" name="price">
                  <InputNumber
                    min={0}
                    style={{ width: 300 }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    size="large"
                    value={bulkPrice.price}
                    onChange={(value) => setBulkPrice({ ...bulkPrice, price: value })}
                  />
                </Form.Item>

              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                style={{ marginTop: 2, marginBottom: 15 }}
              >
                <div>Mô tả</div>
                <CKEditor
                  initData={product && product.description && parse(product.description)}
                  onChange={(e) => setDescription(e.editor.getData())}
                />
              </Col>

            </Row>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Hình ảnh" key="2">
            <h3 style={{ marginBottom: 20 }}>Danh sách hình ảnh món ăn </h3>
            <Row wrap={false}>
              {imagesProduct.map((image) => (
                <div style={{ marginRight: 30 }}>
                  <Badge
                    count={
                      <CloseCircleFilled
                        onClick={async () => {

                          const indexImage = imagesProduct.findIndex((img) => img === image)
                          if (indexImage !== -1) {
                            const imagesNew = [...imagesProduct]
                            imagesNew.splice(indexImage, 1)
                            setImagesProduct([...imagesNew])
                          }
                        }}
                        style={{ fontSize: 22, color: '#ff4d4f', cursor: 'pointer' }}
                      />
                    }
                  >
                    <img
                      src={image}
                      alt=""
                      style={{ width: 130, height: 130, objectFit: 'cover' }}
                    />
                  </Badge>
                </div>
              ))}

              <Upload
                accept="image/*"
                listType="picture-card"
                showUploadList={false}
                className={styles['product-upload-image']}
                data={async (file) => {
                  setLoadingUpload(true)
                  const url = await uploadFile(file)
                  setLoadingUpload(false)
                  console.log("uploaded");
                  if (url) {
                    console.log("uploaded-getSignedUrl");
                    var signedUrl = await getSignedUrl(url);
                    console.log("uploaded-getSignedUrl", signedUrl);
                    const imagesNew = [...imagesProduct, signedUrl];
                    setImagesProduct([...imagesNew])
                  }
                }}
              >
                <div>
                  {loadingUpload ? (
                    <LoadingOutlined />
                  ) : (
                    <PlusCircleFilled style={{ color: 'rgba(128, 128, 128, 0.3)', fontSize: 20 }} />
                  )}
                  <div style={{ marginTop: 8, color: '#808080' }}>Tải lên</div>
                </div>
              </Upload>
            </Row>
          </Tabs.TabPane>

        </Tabs>
      </Form>
    </div>
  ) : (
    <NotSupportMobile />
  )
}
